// @flow
import { PointOfConnectionProperties } from "../model/viewModel/pointOfConnectionProperies";

export const getPointOfConnectionProperties = (
  voltDropPercent,
  voltRisePercent,
  loopResistanceMilliohm,
  includesDownstreamLoad,
  includesTransformerResistance,
  geometry,
  annotation,
  styles,
) => {
  let pointOfConnectionProperties: PointOfConnectionProperties = new PointOfConnectionProperties();
  pointOfConnectionProperties.voltDropPercent = voltDropPercent;
  pointOfConnectionProperties.voltRisePercent = voltRisePercent;
  pointOfConnectionProperties.loopResistanceMilliohm = loopResistanceMilliohm;
  pointOfConnectionProperties.includesDownstreamLoad = includesDownstreamLoad;
  pointOfConnectionProperties.includesTransformerResistance = includesTransformerResistance;
  pointOfConnectionProperties.geometry = geometry;
  pointOfConnectionProperties.annotation = annotation;
  pointOfConnectionProperties.styles = styles;
  return pointOfConnectionProperties;
};
